<template>
    <div class="col-xl-3 col-lg-12 theiaStickySidebar">
      <!-- Sidebar Card -->
      <div class="card sidebar-card">
        <div class="card-body">
          <!-- Header Section -->
          <div class="sidebar-header">
            <div class="icon-circle" @click="openImageModal">
              <img
                v-if="initialInfo.organization_logo"
                :src="initialInfo.organization_logo_url"
                alt="Organization Image"
                class="uploaded-image"
              />
              <i v-else class="fas fa-upload"></i>
            </div>
            <div class="d-flex justify-content-center mt-2">
              <span :class="getPriorityBadgeClass(leadInfo?.lead_priority)" class="badge">
                {{ leadInfo?.lead_priority }}
              </span>
            </div>
            <h5 class="fw-bold mt-2 text-center">{{initialInfo?.organization_name}}</h5>
            <div class="row small-text mt-2">
              <div class="col-md-12">
                <span style="color: blue">Created by</span> {{leadInfo?.created_by?.name}} <br />
                <!-- <span>18 Apr, 2023</span> -->
              </div>
              <!-- <div class="col-md-6 text-muted">
                <span style="color: blue">Last Updated</span> Not updated yet
              </div> -->
            </div>
          </div>
  
          <!-- Address -->
          <div class="address mt-3">
            <span class="fw-medium" style="color: blue">Address: </span>
            <span class="text-muted">{{initialInfo?.address}}</span>
          </div>
  
          <!-- Expandable Menu Sections -->
          <div class="dropdown-section mt-3">
            <div class="menu-item">
              <button class="btn dropdown-btn" @click="toggleSection('concernPersons')">
                Concern Persons
                <i :class="getIcon('concernPersons')" class="ms-auto"></i>
              </button>
              <div v-if="expanded.concernPersons" class="expandable-box">
                <div v-for="(concernInfo, i) in concernPersonInfo" :key="i" class="person">
                  <p class="clickable-text mb-1" style="font-size: 13px;" @click="handlePersonClick(concernInfo)">{{concernInfo?.name}} ({{concernInfo?.designation?.name}})</p>
                  <p class="mb-1" style="font-size: 10px;">
                    <i class="fas fa-phone"></i><u>{{concernInfo?.phone[0]}}</u>
                  </p>
                  <p class="mb-1" style="font-size: 10px;">
                    <i class="fas fa-envelope"></i><u>{{concernInfo?.email[0]}}</u>
                  </p>
                </div>
              </div>
            </div>
  
            <div class="menu-item">
              <button class="btn dropdown-btn" @click="toggleSection('details')">
                Details
                <i :class="getIcon('details')" class="ms-auto"></i>
              </button>
              <div v-if="expanded.details" class="expandable-box">
                <p><b>Industry Type:</b> {{initialInfo?.industry?.type}}</p>
                <p><b>Information Source:</b> {{initialInfo?.information_source?.name}}</p>
                <p><b>Website:</b> <a :href="initialInfo?.website_link" target="_blank">{{initialInfo?.website_link}}</a></p>
                <p><b>Zone:</b> {{initialInfo?.zone?.name}}</p>
                <p><b>Phone:</b> {{initialInfo?.phone}}</p>
                <p v-if="initialInfo.social_networks">
                  <b>Social Networks: </b> 
                  <span v-for="(social, i) in initialInfo.social_networks" class="badge bg-primary me-1">
                    <a
                      :href="social?.URL"
                      class="text-white text-decoration-none"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {{ social?.mediaName?.name }}
                    </a>
                  </span>
                </p>
                <p class="text-center">
                  <b><u>Exhibitions</u></b>
                </p>
                <div v-if="initialInfo.exhibitions" v-for="(exhibition, i) in initialInfo.exhibitions" :key="i" class="mb-3 p-3 border rounded bg-light">
                  <p><b>Exhibition Name:</b> {{ exhibition?.exhibition_id?.name }}</p>
                  <p><b>Employee:</b> {{ exhibition?.employee_id?.name }}</p>
                </div>
              </div>
            </div>

            <!-- <div class="menu-item">
              <button class="btn dropdown-btn">
                Attached Files
                <i :class="getIcon('details')" class="ms-auto"></i>
              </button>
            </div> -->

            <!-- <div class="menu-item">
              <button class="btn dropdown-btn">
                Leads
                <i :class="getIcon('details')" class="ms-auto"></i>
              </button>
            </div> -->

            <div class="menu-item">
              <button class="btn dropdown-btn">
                Quotations
                <i :class="getIcon('details')" class="ms-auto"></i>
              </button>
            </div>

            <div class="menu-item">
              <button class="btn dropdown-btn">
                Orders
                <i :class="getIcon('details')" class="ms-auto"></i>
              </button>
            </div>
            <button @click="goToEditPage" class="btn btn-primary btn-sm mt-2" style="width: 100%">Edit</button>
          </div>
        </div>
      </div>
      <!-- /Sidebar Card -->

      <!-- Image Upload Modal -->
      <div
        v-if="showImageModal"
        class="modal-overlay"
        @click.self="closeImageModal"
      >
        <div class="modal-content">
          <h5 class="modal-title">Upload Organization Image</h5>
          <div class="custom-file-upload mt-3 mb-3">
            <label for="fileInput" class="custom-file-label">
              Choose a file
              <input
                id="fileInput"
                type="file"
                accept="image/*"
                @change="handleFileChange"
              />
            </label>
            <div class="text-danger" v-if="errors.organization_logo">
                {{ errors.organization_logo[0] }}
            </div>
          </div>
          <div v-if="previewImage" class="image-preview">
            <img :src="previewImage" alt="Preview" />
          </div>
          <button class="btn btn-primary mt-3" @click="uploadImage">
            Upload
          </button>
          <button class="btn btn-secondary mt-3" @click="closeImageModal">
            Cancel
          </button>
        </div>
      </div>

      <leads-concern-person-details-modal v-if="isShowModal"></leads-concern-person-details-modal>
    </div>
  </template>
  
  <script>
  import http from "@/utils/http";

  export default {
    props: {
      leadId: {
        type: String,
        required: true,
      },
      concernPersonInfo: {
        type: Array,
        required: true,
      },
      initialInfo: {
        type: Object,
        required: true,
      },
      leadInfo: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        isShowModal: false,
        expanded: {
          concernPersons: false,
          details: false,
        },
        showImageModal: false,
        previewImage: null,
        logoFile: null,
        errors: []
      };
    },
    computed: {
      getPriorityBadgeClass() {
        return (priority) => {
          switch (priority?.toLowerCase()) {
            case "very good":
              return "badge-success"; // Green
            case "good":
              return "badge-primary"; // Blue
            case "very low":
              return "badge-danger"; // Red
            case "low":
              return "badge-warning"; // Yellow
            default:
              return "badge-secondary"; // Gray for unknown priority
          }
        };
      },
    },
    methods: {
      openImageModal() {
        this.showImageModal = true;
        this.previewImage = this.initialInfo.organization_logo_url
      },
      closeImageModal() {
        this.showImageModal = false;
        this.previewImage = null;
        this.logoFile = null
      },
      handleFileChange(event) {
        const file = event.target.files[0];
        if (file) {
          this.logoFile = file
          const reader = new FileReader();
          reader.onload = (e) => {
            this.previewImage = e.target.result;
          };
          reader.readAsDataURL(file);
        }
      },
      async uploadImage() {
        if(this.logoFile){
          const endpoint = "/upload-organization-logo";
          const method = "post";
          const formData = new FormData();
  
          formData.append('lead_id', this.leadId);
          formData.append('organization_logo', this.logoFile);
          try {
              const response = await http[method](endpoint, formData, {
                  headers: {
                      'Content-Type': 'multipart/form-data',
                  },
              });
              this.$toast.success(response.data.message);
              this.$emit("logoUploaded");
              this.closeImageModal()
          } catch (error) {
              this.isLoading= false
              this.errors = error.response.data.errors;
          } finally {
          this.isLoading = false;
          }
        }
        else{
          this.$toast.error('please select the file!');
        }
      },
      goToEditPage() {
        this.$router.push(`/leads-organization/${this.leadId}/initial-info`);
      },
      toggleSection(section) {
        this.expanded[section] = !this.expanded[section];
      },
      getIcon(section) {
        return this.expanded[section] ? "fas fa-chevron-up" : "fas fa-chevron-down";
      },
      handlePersonClick(concernInfo) {
        this.isShowModal = true;
        setTimeout(() => {
          this.$emitter.emit("show-persons-details", concernInfo);
        })
      },
    },
  };
  </script>
  
  <style scoped>
  .badge {
    display: inline-block;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: bold;
    text-transform: capitalize;
  }

  .badge-success {
    background-color: #28a745;
    color: white;
  }

  .badge-primary {
    background-color: #007bff;
    color: white;
  }

  .badge-danger {
    background-color: #dc3545;
    color: white;
  }

  .badge-warning {
    background-color: #ffc107;
    color: black;
  }

  .badge-secondary {
    background-color: #6c757d;
    color: white;
  }
  .sidebar-card {
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: #f8f9fa;
    padding: 15px;
  }
  
  .sidebar-header {
    /* text-align: center; */
    margin-bottom: 20px;
  }
  .sidebar-header .icon-circle {
    width: 60px;
    height: 60px;
    background-color: #e0f0ff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
    color: #007bff;
    margin: 0 auto;
    cursor: pointer;
    overflow: hidden;
  }
  .uploaded-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050;
  }

  .modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    max-width: 400px;
    width: 100%;
    text-align: center;
    z-index: 1051;
  }

  .custom-file-upload {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .custom-file-label {
    position: relative;
    display: inline-block;
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1rem;
    transition: background-color 0.3s ease;
  }

  .custom-file-label:hover {
    background-color: #0056b3;
  }

  .custom-file-label input[type="file"] {
    display: none;
  }

  .image-preview {
    text-align: center;
    margin-top: 15px;
  }

  .image-preview img {
    max-width: 100%;
    max-height: 200px;
    border: 1px solid #ddd;
    border-radius: 5px;
  }

  /* .image-preview img {
    max-width: 100%;
    height: auto;
    margin-top: 10px;
  } */
  
  .address {
    font-size: 0.9rem;
    color: #6c757d;
  }
  
  .dropdown-section .menu-item {
    margin-bottom: 10px;
  }
  
  .dropdown-btn {
    width: 100%;
    text-align: left;
    background-color: #fff;
    border: 1px solid #ddd;
    margin-bottom: 8px;
    padding: 5px 12px;
    font-size: 1rem;
    color: #495057;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .expandable-box {
    background-color: #f8f9fa;
    padding: 8px 8px;
    border: 1px solid #000;
    margin-top: 8px;
    border-radius: 5px;
  }
  
  .person {
    margin-bottom: 15px;
    font-size: 0.9rem;
  }
  
  .person i {
    margin-right: 8px;
  }
  .clickable-text {
    color: #007bff;
    cursor: pointer;
    text-decoration: underline;
  }
  </style>
  